import { defineStore } from 'pinia'

import type { CategoryDetailData } from '@/types/api'

export const useCategoryStore = defineStore('category', () => {
  const categoryMap = reactive<Record<number, CategoryDetailData>>({})

  const setToCategoryMap = (category: CategoryDetailData) => {
    const cid = category.id

    if (cid) {
      categoryMap[cid] = category
    }
  }

  return {
    categoryMap,
    setToCategoryMap,
  }
})
